import { getCrossBrowserFullscreenElement, getCrossBrowserFullscreenEnabled } from 'util/fullscreen';
import React from 'react';

export const useFullscreenStatus = () => {
    const [isFullscreen, setIsFullscreen] = React.useState(false);

    const setFullscreen = () => {
        const fullscreenEnabled = getCrossBrowserFullscreenEnabled();
        if (fullscreenEnabled)
            document.documentElement.requestFullscreen().catch(() => {
                setIsFullscreen(false);
            });
    };

    React.useLayoutEffect(() => {
        const handleFullscreenChange = () => {
            // Safari понимает только document.webkitCurrentFullScreenElement в данный момент
            const fullscreenElement = getCrossBrowserFullscreenElement();
            const isFullscreenElement = fullscreenElement !== null;
            setIsFullscreen(isFullscreenElement);
        };

        document.addEventListener('fullscreenchange', handleFullscreenChange);
        document.addEventListener('onwebkitfullscreenchange', handleFullscreenChange);

        return () => {
            document.removeEventListener('fullscreenchange', handleFullscreenChange);
            document.removeEventListener('onwebkitfullscreenchange', handleFullscreenChange);
        };
    });

    return { isFullscreen, setFullscreen };
};
